import styled from "styled-components";

export const QuitImage = styled.img`
  margin-top: 70px;
  margin-bottom: 50px;
  max-height: 200px;
`;
